"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMyClient = exports.createClient = void 0;
var ByCustomerClient_1 = require("./ByCustomerClient");
var createApiBuilder_1 = require("./createApiBuilder");
var MeClient_1 = require("./MeClient");
/** @deprecated since v0.3.5; use createClient(options) and then call withCustomer() if desired */
function createClient(optionsOrCustomerId, options) {
    if (typeof optionsOrCustomerId === 'string') {
        if (!options) {
            throw new Error('Options not specified');
        }
        return new ByCustomerClient_1.ByCustomerClient((0, createApiBuilder_1.createApiBuilder)(options), optionsOrCustomerId);
    }
    else {
        return new MeClient_1.MeClient((0, createApiBuilder_1.createApiBuilder)(optionsOrCustomerId));
    }
}
exports.createClient = createClient;
/**
 * @deprecated since v0.3.5; use createClient(options)
 */
function createMyClient(options) {
    return createClient(options);
}
exports.createMyClient = createMyClient;
//# sourceMappingURL=createClient.js.map